import * as Sentry from "@sentry/react";

import { isLocal } from "~/config";
import { env } from "~/env";

export const sentryConfig = () => {
  if (!isLocal) {
    Sentry.init({
      dsn: env.VITE_SENTRY_DSN_PUBLIC,
      environment: env.VITE_SENTRY_ENVIRONMENT,
    });
  }
};
